module.exports = __webpack_public_path__ + "img/instagram-reels-plus-feed-icon-blue.svg";